export const GET_LIST_CAMPAIGN_ACTION = "GET_LIST_CAMPAIGN_ACTION";
export const GET_LIST_CAMPAIGN_SPLASH_ACTION =
	"GET_LIST_CAMPAIGN_SPLASH_ACTION";
export const SET_LIST_CAMPAIGN_ACTION = "SET_LIST_CAMPAIGN_ACTION";

export const GET_CAMPAIGN_DETAIL_ACTION = "GET_CAMPAIGN_DETAIL_ACTION";
export const SET_CAMPAIGN_DETAIL_ACTION = "SET_CAMPAIGN_DETAIL_ACTION";

export const GET_LOYALTY_DETAIL_ACTION = "GET_LOYALTY_DETAIL_ACTION";
export const SET_LOYALTY_DETAIL_ACTION = "SET_LOYALTY_DETAIL_ACTION";

export const GET_MERCHANDISING_DETAIL_ACTION =
	"GET_MERCHANDISING_DETAIL_ACTION";
export const SET_MERCHANDISING_DETAIL_ACTION =
	"SET_MERCHANDISING_DETAIL_ACTION";

export const GET_LOYALTY_POINT_DETAIL_ACTION =
	"GET_LOYALTY_POINT_DETAIL_ACTION";
export const SET_LOYALTY_POINT_DETAIL_ACTION =
	"SET_LOYALTY_POINT_DETAIL_ACTION";

export const SET_MENU_PROMOTION_ACTION = "SET_MENU_PROMOTION_ACTION";
